module.exports = __webpack_public_path__ + "static/media/en-check-scope_4.bdcabc78.png";